import styled from '@emotion/styled';
import { Button } from '@mui/material';

const BigFilterButton = styled(Button)`
  @media (max-width: 768px) {
    width: auto;
    min-width: 0;
    height: auto;
    border-radius: 16px;
    margin: 0;
    flex: 1;
    & .MuiButton-label {
      display: flex;
      flex-direction: column;
    }
    box-shadow: 0px 1.02919px 1.02919px 0px rgba(171, 171, 171, 0.33);
    font-size: 16px;
    background: ${props => (props.className === 'active' ? '#FFFFFF' : '#fff3dc50')};
  }
  height: 45px;
  margin: 10px 10px;
  padding-left: 20px;
  padding-right: 20px;
  width: fit-content;
  min-width: 200px;
  border-radius: 100px;
  white-space: nowrap;
  text-align: center;
  color: #000;
  font-family: var(--font-work-sans);
  font-size: 23.882px;
  text-transform: none;
  font-style: normal;
  font-weight: 500;
  line-height: 136.8%; /* 32.671px */
  background: ${props => (props.className === 'active' ? '#FFFFFF' : '#fff3dc50')};
  /* display: inline-block; */
  :hover {
    cursor: pointer;
    background: #ffffff;
  }
`;

export default BigFilterButton;

export const LocationStyledButton = styled(Button)`
  @media (max-width: 768px) {
    display: flex;
    width: fit-content;
    padding: 9px 18px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: rgba(255, 243, 220, 0.5);
    /* menu drop */
    box-shadow: 0px 24px 32px 0px rgba(171, 171, 171, 0.33);
    background: ${props => (props.className === 'active' ? '#FFFFFF' : '#fff3dc50')};
  }
  height: 45px;
  margin: 10px 10px;
  padding-left: 20px;
  padding-right: 20px;
  width: fit-content;
  min-width: 200px;
  border-radius: 100px;
  white-space: nowrap;
  text-align: center;
  color: #000;
  font-family: var(--font-work-sans);
  font-size: 23.882px;
  text-transform: none;
  font-style: normal;
  font-weight: 500;
  line-height: 136.8%; /* 32.671px */
  background: ${props => (props.className === 'active' ? '#FFFFFF' : '#fff3dc50')};
  /* display: inline-block; */
  :hover {
    cursor: pointer;
    background: #ffffff;
  }
`;
